import React, { useEffect, useMemo, useRef, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import apiCall from "../../Api/api";
import { useParksContext } from "../../../provider/ParksProvider";
import { useSharedSafariContext } from "provider/ShareSafariProvider";

import { useMasterContext } from "provider/MasterProvider";
import StepForm1 from "./steps/StepForm1";
import StepForm2 from "./steps/StepForm2";
import StepForm3 from "./steps/StepForm3";

function OrganizeSharedSafariModal() {
  const { sharedSafariData, summary, filters, toggleOragnize, organizeSafari, step, noOfStep, organizeSafariErrors, sharedSafariDispatch } = useSharedSafariContext();
  const today = new Date().toISOString().split("T")[0];
  console.log(step)
  const { parksData, pageIndex } = useParksContext();

  const [title, setTitle] = useState("");
  const [number, setNumber] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [totalSeat, setTotalSeat] = useState("");
  const [shareSeat, setShareSeat] = useState("");
  const [totaleSeatError, setTotalSeatError] = useState(false);
  const [shareSeatError, setShareSeatError] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState(false);
  const [theme, setTheme] = useState("");
  const [stayCategory, setStayCategory] = useState("");
  const [otp, setOtp] = useState(Array(6).fill(""));
  const otpRefs = useRef([]);
  const [numberOfSafaris, setNumberOfSafaris] = useState(1);
  const [sharedSafariImage, setSharedSafariImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [displayImage, setDisplayImage] = useState("");

  useEffect(() => {
    otpRefs.current = Array(6)
      .fill()
      .map((_, i) => otpRefs.current[i] || React.createRef());
  }, []);

  const processedParks = useMemo(() => {
    return parksData?.map((park) => ({
      ...park,
    }));
  }, [parksData, pageIndex]);


  const handleVerify = () => {

    handleNext();
  }



  const organizeSafariUp = async (formData) => {
    try {
      const response = await apiCall({
        url: "sharesafari/organize-safari",
        method: "POST",
        data: formData,
      });


    } catch (error) {
      console.error("Error:", error?.data || error.message);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();

    switch (step) {
      case 1:
        formData.append("share_safari_title", organizeSafari?.share_safari_title);
        formData.append("park_id", organizeSafari?.park_id);
        formData.append("start_date", organizeSafari?.start_date);
        formData.append("end_date", organizeSafari?.end_date);
        formData.append("no_of_safari", organizeSafari?.no_of_safari);
        setLoading(false);
        return;

      case 2:
        formData.append("share_safari_agenda_id", number); // e.g., agenda ID
        setLoading(false);
        return;

      case 3:
        // formData.append("estimate_price_min", minPrice);
        formData.append("estimate_price_max", maxPrice);
        setLoading(false);
        return;

      case 4:
        formData.append("total_seat", totalSeat);
        formData.append("share_seat", shareSeat);
        setLoading(false);
        return;

      case 5:
        formData.append("safari_plan", title); // Assuming same title used
        setLoading(false);
        return;

      case 6:
        formData.append("stay_category_id", stayCategory);
        if (sharedSafariImage) {
          formData.append("shared_safari_image", sharedSafariImage);
        }
        break;

      default:
        console.warn("Unhandled step in submission");
        break;
    }

    await organizeSafariUp(formData);
    setLoading(false);
  };



  const handleChange = (e) => {
    setNumberOfSafaris(Number(e.target.value));
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSharedSafariImage(file); // <--- Needed for upload
      const imageUrl = URL.createObjectURL(file);
      setDisplayImage(imageUrl);
    }
  };



  const validateStep1 = () => {
    const errors = {
      share_safari_title: '',
      park_id: '',
      start_date: '',
      end_date: '',
      no_of_safari: '',
    };

    if (!organizeSafari?.share_safari_title?.trim()) {
      errors.share_safari_title = "Title is required";
    }

    if (!organizeSafari?.park_id) {
      errors.park_id = "Please select a park";
    }

    if (!organizeSafari?.start_date) {
      errors.start_date = "Start date is required";
    } else if (organizeSafari.start_date < today) {
      errors.start_date = "Start date cannot be before today";
    }

    if (!organizeSafari?.end_date) {
      errors.end_date = "End date is required";
    } else if (
      organizeSafari?.start_date &&
      organizeSafari.end_date <= organizeSafari.start_date
    ) {
      errors.end_date = "End date must be after start date";
    }

    // Dispatch the errors
    sharedSafariDispatch({
      type: "SET_ERRORS_ORGANIZE_SHARE_SAFARI",
      payload: errors,
    });

    // If all error values are empty, the form is valid
    return Object.values(errors).every((msg) => msg === "");
  };


  const validateStep2 = () => {
    const errors = {
      share_safari_agenda_id: '',
      stay_category_id: '',
      estimate_price_min: '',
      estimate_price_max: '',
      total_seat: '',
      share_seat: '',
    };

    const {
      share_safari_agenda_id,
      stay_category_id,
      estimate_price_min,
      estimate_price_max,
      total_seat,
      share_seat,
    } = organizeSafari;

    // Validate agenda (theme)
    if (!share_safari_agenda_id) {
      errors.share_safari_agenda_id = "Please select a theme";
    }

    // Validate stay category
    if (!stay_category_id) {
      errors.stay_category_id = "Please select a stay category";
    }

    // Validate estimate_price_min
    if (!estimate_price_min || estimate_price_min <= 0) {
      errors.estimate_price_min = "Min price must be greater than 0";
    } else if (estimate_price_max && estimate_price_min >= estimate_price_max) {
      errors.estimate_price_min = "Min must be less than Max price";
    }

    // Validate estimate_price_max
    if (!estimate_price_max || estimate_price_max <= 0) {
      errors.estimate_price_max = "Max price must be greater than 0";
    } else if (estimate_price_min && estimate_price_max <= estimate_price_min) {
      errors.estimate_price_max = "Max must be greater than Min price";
    }

    // Validate total_seat
    if (!total_seat || isNaN(total_seat) || parseInt(total_seat) <= 0) {
      errors.total_seat = "Total seat is required and must be greater than 0";
    }

    // Validate share_seat
    if (!share_seat || isNaN(share_seat) || parseInt(share_seat) <= 0) {
      errors.share_seat = "Please select valid share seats";
    } else if (parseInt(share_seat) >= parseInt(total_seat)) {
      errors.share_seat = "Share seats must be less than total seats";
    }

    // Dispatch the errors
    sharedSafariDispatch({
      type: "SET_ERRORS_ORGANIZE_SHARE_SAFARI",
      payload: errors,
    });

    // Return validation result
    return Object.values(errors).every((msg) => msg === "");
  };

 const validateStep3 = () => {
  const errors = {
    shared_safari_image: '',
    safari_plan: '',
  };

  const { shared_safari_image, safari_plan } = organizeSafari;

  // Validate image
  if (!shared_safari_image) {
    errors.shared_safari_image = "Please upload a display image";
  }

  // Validate safari plan
  if (!safari_plan || safari_plan.trim() === "") {
    errors.safari_plan = "Safari plan is required";
  }

  // Dispatch the errors
  sharedSafariDispatch({
    type: "SET_ERRORS_ORGANIZE_SHARE_SAFARI",
    payload: errors,
  });

  // Return whether the step is valid
  return Object.values(errors).every((msg) => msg === "");
};

  const validateStep4 = () => {
    return true;
  };
  const validateStep5 = () => {
    return true;
  };

  const handleTotalSeatChange = (e) => {
    const value = e.target.value;
    setTotalSeat(value);
    setShareSeat("");
    setTotalSeatError(value.trim() === "");
  };

  const handleShareSeatChange = (e) => {
    setShareSeat(e.target.value);
    setShareSeatError(e.target.value.trim() === "");
  };

  const generateShareSeatOptions = () => {
    const total = parseInt(totalSeat);
    if (isNaN(total) || total <= 0) return [];
    return Array.from({ length: total - 1 }, (_, i) => i + 1);
  };

  const stepValidators = [validateStep1, validateStep2, validateStep3, validateStep4, validateStep5];
  const handleNext = () => {
    if (Number(step) < noOfStep && stepValidators[Number(step) - 1]()) {
      const nextStep = Number(step) + 1;
      sharedSafariDispatch({
        type: "ORGANIZE_SF_SET_STEP",
        payload: nextStep,
      });
    }
  };
  const handleBack = () => {
    if (step > 1) {
      const nextStep = Number(step) - 1;
      sharedSafariDispatch({
        type: "ORGANIZE_SF_SET_STEP",
        payload: nextStep,
      });
    }
  };




 


  const renderStep3 = () => (
    <Row className="pt-3">
      <Col xs={6} className="mobileSetimg mb-2">
        <label for="" class="Modal_label">Current Display Image</label>
        {displayImage ? (
          <img
            src={displayImage}
            alt="Current"
            width="100%"
            height="100px"
            style={{ objectFit: "contain" }}
          />
        ) : (
          <div style={{ height: "100px", background: "#f0f0f0" }}>No image selected</div>
        )}

      </Col>
      <Col xs={6} className="mb-2">
        <label htmlFor="fileInput" class="Modal_label">Select Picture</label>
        <input
          type="file"
          id="fileInput"
          className="form-control"
          onChange={handleFileChange}
        />
      </Col>
      <Col xs={12}>
        <label for="" class="Modal_label">Plan </label>
        <textarea name="" id="" className="form-control" placeholder="Enter Page Detail!" style={{ height: "160px" }}>


        </textarea>
      </Col>
    </Row>
  );
  const renderStep4 = () => (
    <Row className="pt-3">
      <Col xs={12} className="mb-3 text-center">
        <label className="Modal_label text-center"> Mobile Number Verification
        </label>
        <p className="font_colorfomr">"A One Time Passcode will be sent to your mobile number."</p>
      </Col>
      <Col xs={12} className="mb-2">
        <label className="Modal_label">
          Mobile Number <span className="necessary">*</span>
        </label>
        <div className="mb-3 field-sharedsafariform-share_safari_title required">
          <input
            type="tel"
            className={`form-control ${mobileNumberError ? "is-invalid" : ""}`}
            placeholder="Enter number"
            value={mobileNumber}
            onChange={(e) => setMobileNumber(e.target.value)}
          />
          {mobileNumberError && (
            <div className="invalid-feedback">Mobile number is required</div>
          )}
        </div>
      </Col>

    </Row>
  );
  const renderStep5 = () => (
    <Row className="pt-3">
      <Col xs={12} className="mb-3 text-center">
        <label className="Modal_label text-center">Mobile Number Verification</label>
        <p className="font_colorfomr px-lg-5">
          We will send you a One Time Passcode on this Mobile Number
        </p>
        <label className="Modal_label text-center">+91-9090909090 <span><button className="changebtn ms-2">Change</button></span></label>
      </Col>

      <Col xs={12} className="mb-3 d-flex justify-content-center gap-2">
        {otp.map((digit, index) => (
          <input
            key={index}
            type="text"
            maxLength={1}
            className="form-control text-center"
            style={{ width: "50px", fontSize: "24px" }}
            value={digit}
            ref={otpRefs.current[index]}
            onChange={(e) => {
              const val = e.target.value;
              if (/^[0-9]$/.test(val) || val === "") {
                const newOtp = [...otp];
                newOtp[index] = val;
                setOtp(newOtp);

                if (val !== "" && index < otp.length - 1) {
                  otpRefs.current[index + 1].current.focus();
                }
              }
            }}
            onKeyDown={(e) => {
              if (e.key === "Backspace" && otp[index] === "" && index > 0) {
                otpRefs.current[index - 1].current.focus();
              }
            }}
          />
        ))}

      </Col>
      <Col xs={12} className="text-center m-auto">
        <button className="changebtn d-block text-center m-auto" style={{ fontStyle: "italic" }}>Resend OTP</button>
      </Col>
    </Row>

  );
  const renderStep6 = () => (
    <Row className="pt-3">
      <Col xs={12} className="mb-3 text-center">
        <label className="Modal_label text-center">Mobile Number Verification</label>
        <p className="font_colorfomr px-lg-5">
          We will send you a One Time Passcode on this Mobile Number
        </p>
        <label className="Modal_label text-center">+91-9090909090 <span><button className="changebtn ms-2">Change</button></span></label>
      </Col>

      <Col xs={12} className="mb-3 text-center mt-4">
        <h3 className="mb-0" style={{ fontStyle: "italic" }}>Thank you"</h3>
        <p style={{ fontStyle: "italic" }}>Your OTP has been verified successfully.</p>
      </Col>

    </Row>

  );

  const handleClose = () => {
    sharedSafariDispatch({ type: "ORGANIZE_SHARE_SAFARI_TOGGLE", payload: false });
  }
  return (
    <Modal show={toggleOragnize} onHide={handleClose} centered>
      <Modal.Header className="justify-content-center">
        <h2 className="modal-title fs-5">Organize a Shared Safari</h2>
      </Modal.Header>
      <Modal.Body className="px-3 pt-0">
        <Form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="py-3 px-2">
            <Container fluid="lg">
              <div>
                {step === 1 && <StepForm1 />}
                {step === 2 && <StepForm2 />}
                {step === 3 && <StepForm3 />}
                {step === 4 && renderStep4()}
                {step === 5 && renderStep5()}
                {step === 6 && renderStep6()}
              </div>
              <Row>
                <Col lg={12} className="margin-remove pt-3">
                  <div className="creat-safri d-flex justify-content-end">
                    {step === 1 ? (
                      <button className="cancel_btn" onClick={handleClose}>
                        Cancel
                      </button>
                    ) : (
                      <button className="cancel_btn" onClick={handleBack}>
                        Back
                      </button>
                    )}

                    {step < 5 ? (
                      <button
                        className="btn safari_create font_set w-auto ms-2 next_screen"
                        onClick={handleNext}
                      >
                        Next
                      </button>
                    ) : step === 5 ? (
                      <button
                        className="btn safari_create font_set w-auto ms-2 next_screen"
                        onClick={handleVerify}
                      >
                        Verify
                      </button>
                    ) : (
                      <button
                        className="btn safari_create font_set w-auto ms-2 next_screen"

                      >
                        Create
                      </button>
                    )}
                  </div>

                </Col>
              </Row>


              <div className="dots-container text-center mt-3">
                <span
                  className={`dot ${step === 1 ? "active" : ""}`}
                  onClick={handleBack}
                ></span>
                <span
                  className={`dot ${step === 2 ? "active" : ""}`}
                  onClick={handleBack}
                ></span>
                <span
                  className={`dot ${step === 3 ? "active" : ""}`}
                  onClick={handleBack}
                ></span>
                <span
                  className={`dot ${step === 4 ? "active" : ""}`}
                  onClick={handleBack}
                ></span>
                <span
                  className={`dot ${step === 5 ? "active" : ""}`}
                  onClick={handleBack}
                ></span>
                <span
                  className={`dot ${step === 6 ? "active" : ""}`}
                  onClick={handleBack}
                ></span>
              </div>
            </Container>
          </div>

        </Form>


      </Modal.Body>

    </Modal>
  );
}

export default OrganizeSharedSafariModal;
